module.exports = __webpack_public_path__ + "static/fonts/fa-solid-900.d6d8d5d.woff2";


//////////////////
// WEBPACK FOOTER
// ./static/fontawesome-5.10.2/webfonts/fa-solid-900.woff2
// module id = 341
// module chunks = 1